import * as Yup from 'yup';
import { ref } from 'yup';

export const createAccountSchema = Yup.object().shape({   
    register_type: Yup.string().required('Email is required'),
    first_name: Yup.string().required('First name is required'),
    phone_area_code: Yup.string().required('Area code is required'),  
    //phone_nr: Yup.string().required('Phone number is required'),
    last_name: Yup.string().when('register_type', {
        is: 'company',
        then: () => Yup.string().required('Last name is required'),
    }),
    country: Yup.string().when('register_type', {
        is: 'company',
        then: () => Yup.string().required('Country is required'),
    }),     
    country_individual: Yup.string().when('register_type', {
        is: 'individual',
        then: () => Yup.string().required('Country is required'),
    }),     
    company_name: Yup.string().when('register_type', {
        is: 'company',
        then: () => Yup.string().required('Company name is required'),
    }),        
    email: Yup.string()
        .when('register_type', {
            is: 'company',
            then: (schema) => schema.required('Email is required').email('Enter a valid email address'),
        }),    
    password: Yup.string().when('register_type', {
        is: 'individual',
        then: () => Yup.string().required('Password is required').min(8, "Password must be at least 8 characters long"),
    }),    
    password_confirmation: Yup.string()
        .when('register_type', {
            is: 'individual', 
            then: schema => schema.required('Password confirmation is required').oneOf([ref('password')], 'Passwords do not match'),
        }),
    phone_nr: Yup.string()
        .required('Phone number is required')
        .matches(/^\d+$/, 'Phone number should contain only digits') // Ensure it's all digits
        .test('phone-length', 'Phone number must be 9 digits for AED/KSA, 8 digits for other countries', function(value) {
          const { country } = this.parent; // Access the `phone_area_code` from form context
    
          // Validate phone length based on country code
          if (country === 'AED' || country === 'SAR') {
            return value && value.length === 9; // 9 digits for AED/SAR
          }
          return value && value.length === 8; // 8 digits for other countries
        })
});

export const loginSchema = Yup.object().shape({
    email: Yup.string().required('Email is required'),
    password: Yup.string()
        .required('Password is required')
        .min(8, "Password must be at least 8 characters long"), 
});

export const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string().required('Email is required').email('Enter a valid email address')
});

export const createPasswordSchema = Yup.object().shape({ 
    password: Yup.string()
        .required('Password is required')
        .min(8, "Password must be at least 8 characters long"),  

    password_confirmation: Yup.string()
        .required('Password confirmation is required')
        .oneOf([Yup.ref('password')], 'Passwords do not match'),    
});

export const guestUserOrderCreationSchema = Yup.object().shape({
    email           : Yup.string().required('Email is required').email('Enter a valid email address'),
    first_name      : Yup.string().required('First name is required'),
    company_name    : Yup.string(),
    phone_nr        : Yup.string().required('Phone number is required'),
    phone_area_code : Yup.string().required('Area code is required'),
    city            : Yup.string().required('City is required'),
    street          : Yup.string().required('Street is required'),
    country         : Yup.string().required('Country is required')
});